module.exports = __webpack_public_path__ + "static/mgmt-consulting-banner-mobile-b3ea8e9fc642fc11a6568c229680ff9a.jpg";